<template>
    <div class="banner">
        <div class="banner-content">
            <div class="banner-content-company">广东豪嘉制冷设备有限公司</div>
            <div class="banner-content-desc">专业的制冷设备与水族解决方案提供商</div>
            <div class="banner-content-tips">
                我们专注于高品质制冷设备的研发与制造，为水族行业提供专业的温控解决方案。凭借15年的行业经验，我们不断创新技术，提供节能环保的产品，为客户创造更大的价值。
            </div>
            <div class="banner-content-btn">
                了解更多<img src="../assets/image/arrow-right.webp" alt="arrow-right">
            </div>
        </div>
        <img src="../assets/image/bg.webp" alt="banner" class="banner-img vue-lazy">
    </div>
</template>

<script>
export default {
  name: 'BannerComp'
}
</script>

<style scoped lang="scss">
.banner {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 72px 80px;

    .banner-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 658px;

        .banner-content-company {
            color: #111827;
            font-family: "Inter";
            font-size: 36px;
            font-style: normal;
            font-weight: 700;
            line-height: 40px;
        }

        .banner-content-desc {
            color: #1F2937;
            font-family: "Inter";
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
        }

        .banner-content-tips {
            color: #4B5563;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            margin: 10px 0 16px;
        }

        .banner-content-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            width: 152px;
            padding: 12px 32px;
            box-sizing: border-box;

            background: #2A5BDA;
            border-radius: 8px;
            color: #FFFFFF;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;

            &:hover {
                background: #1E40AF;
                transform: translateY(-2px);
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            }

            img {
                width: 16px;
                height: 16px;
            }
        }
    }

    .banner-img {
        width: 608px;
        height: 456px;
        object-fit: cover;
        border-radius: 10px;
        transition: transform 0.8s ease-out;
        will-change: transform;
        box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.3);
    }

    @media (prefers-reduced-motion: no-preference) {
        .animate__slideInLeft {
            animation: parallax linear;
            animation-timeline: view();
            animation-range: cover 0% cover 50%;
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 40px 24px;
        gap: 32px;

        .banner-content {
            width: 100%;
            text-align: center;
            align-items: center;

            .banner-content-company {
                font-size: 28px;
                line-height: 32px;
            }

            .banner-content-desc {
                font-size: 16px;
            }

            .banner-content-tips {
                font-size: 14px;
            }
        }

        .banner-img {
            width: 100%;
            height: 240px;
            margin-top: 24px;
        }
    }
}
</style>